export default __webpack_public_path__ + "static/media/sproingl_thumb.8fe038e8.png";